import React, { useState } from "react";
import { Box, Button, Collapse, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import useClientDetails from "../../../../../hooks/useClientDetails";

const MonitorCareTabs = () => {
  const [showData, setShowData] = useState(false);
  const {id: cliendID} = useParams();
  const {fullName} = useClientDetails(cliendID);

  const handleShowClick = () => setShowData(!showData);

  return (
    <Box sx={{ width: "100%", mb: 3 }}>
      {/* Header Button */}
      <Button
        fullWidth
        onClick={handleShowClick}
        variant="contained"
        sx={{
          justifyContent: "flex-start",
          py: 1.8,
          px: 2.5,
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          mb: 2,
          background: showData
            ? "linear-gradient(90deg, #0288d1, #03a9f4)"
            : "linear-gradient(90deg, #1976d2, #42a5f5)",
          color: "white",
          "&:hover": {
            background: "linear-gradient(90deg, #1565c0, #29b6f6)",
          },
        }}
      >
        Monitor Care Plans for {fullName}
      </Button>

      {/* Collapsible Content */}
      <Collapse in={showData}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#fafafa",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No data available
          </Typography>
        </Paper>
      </Collapse>
    </Box>
  );
};

export default MonitorCareTabs;
